import messages from "messages";
import { Button, ButtonProps } from "react-bootstrap";
import getClasses from "utils/getClasses";
import styles from "./styles.module.css";

type Props = {
  onClick: () => void;
} & ButtonProps;
const CancelButton = (rest: Props) => (
  <Button
    variant="outline-primary"
    size="sm"
    className={getClasses("mr-2 px-5", styles["cancel-button"])}
    {...rest}
  >
    {messages.cancel}
  </Button>
);

export default CancelButton;
